import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include user info in headers
api.interceptors.request.use((config) => {
  const currentUserStr = sessionStorage.getItem('currentUser');
  if (currentUserStr) {
    try {
      const currentUser = JSON.parse(currentUserStr);
      config.headers['x-user-email'] = currentUser.email || '';
      config.headers['x-user-name'] = currentUser.name || '';
    } catch (e) {
      // Ignore parse errors
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const getEmployees = () => api.get('/employees');
export const getEmployee = (id) => api.get(`/employees/${id}`);
export const submitTraining = (data) => {
  // If data is FormData (with file upload), use multipart/form-data
  if (data instanceof FormData) {
    return axios.post(`${API_BASE_URL}/training`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  // Otherwise use regular JSON post
  return api.post('/training', data);
};
export const getTrainingRecords = () => api.get('/training');
export const getEmployeeTraining = (id) => api.get(`/training/employee/${id}`);
export const deleteTrainingRecord = (id) => api.delete(`/training/${id}`);
export const deleteTrainingSession = (sessionId) => api.delete(`/training/session/${sessionId}`);
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getQRCode = (url) => api.get('/qrcode', { params: { url } });
export const getCalendarSessions = (year, month) => api.get(`/training/calendar/${year}/${month}`);

// Export API_BASE_URL for components that need direct axios calls
export { API_BASE_URL };

export default api;
